"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var q = Object.defineProperty,
    j = Object.defineProperties;
var H = Object.getOwnPropertyDescriptors;
var L = Object.getOwnPropertySymbols;
var $ = Object.prototype.hasOwnProperty,
    C = Object.prototype.propertyIsEnumerable;

var M = function M(e, t, n) {
  return t in e ? q(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[t] = n;
},
    E = function E(e, t) {
  for (var n in t || (t = {})) {
    $.call(t, n) && M(e, n, t[n]);
  }

  if (L) {
    var _iterator = _createForOfIteratorHelper(L(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        C.call(t, n) && M(e, n, t[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    P = function P(e, t) {
  return j(e, H(t));
};

var S = function S(e, t) {
  var n = {};

  for (var a in e) {
    $.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  }

  if (e != null && L) {
    var _iterator2 = _createForOfIteratorHelper(L(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var a = _step2.value;
        t.indexOf(a) < 0 && C.call(e, a) && (n[a] = e[a]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return n;
};

Object.defineProperties(exports, _defineProperty({
  __esModule: {
    value: !0
  }
}, Symbol.toStringTag, {
  value: "Module"
}));

var y = require("@portabletext/toolkit"),
    w = require("react");

function R(e) {
  return e && typeof e == "object" && "default" in e ? e : {
    default: e
  };
}

var l = R(w);

function B(e, t) {
  var d = t,
      n = d.block,
      a = d.list,
      f = d.listItem,
      h = d.marks,
      I = d.types,
      p = S(d, ["block", "list", "listItem", "marks", "types"]);
  return E(P(E({}, e), {
    block: _(e, t, "block"),
    list: _(e, t, "list"),
    listItem: _(e, t, "listItem"),
    marks: _(e, t, "marks"),
    types: _(e, t, "types")
  }), p);
}

function _(e, t, n) {
  var a = t[n],
      f = e[n];
  return typeof a == "function" || a && typeof f == "function" ? a : a ? E(E({}, f), a) : f;
}

var A = function A(_ref) {
  var e = _ref.children,
      t = _ref.value;
  return l.default.createElement("a", {
    href: t == null ? void 0 : t.href
  }, e);
},
    z = {
  textDecoration: "underline"
},
    F = {
  em: function em(_ref2) {
    var e = _ref2.children;
    return l.default.createElement("em", null, e);
  },
  strong: function strong(_ref3) {
    var e = _ref3.children;
    return l.default.createElement("strong", null, e);
  },
  code: function code(_ref4) {
    var e = _ref4.children;
    return l.default.createElement("code", null, e);
  },
  underline: function underline(_ref5) {
    var e = _ref5.children;
    return l.default.createElement("span", {
      style: z
    }, e);
  },
  "strike-through": function strikeThrough(_ref6) {
    var e = _ref6.children;
    return l.default.createElement("del", null, e);
  },
  link: A
},
    K = {
  number: function number(_ref7) {
    var e = _ref7.children;
    return l.default.createElement("ol", null, e);
  },
  bullet: function bullet(_ref8) {
    var e = _ref8.children;
    return l.default.createElement("ul", null, e);
  }
},
    O = function O(_ref9) {
  var e = _ref9.children;
  return l.default.createElement("li", null, e);
},
    x = function x(e, t) {
  return "Unknown ".concat(e, ", specify a component for it in the `components.").concat(t, "` prop");
},
    U = function U(e) {
  return x("block type \"".concat(e, "\""), "types");
},
    V = function V(e) {
  return x("mark type \"".concat(e, "\""), "marks");
},
    G = function G(e) {
  return x("block style \"".concat(e, "\""), "block");
},
    J = function J(e) {
  return x("list style \"".concat(e, "\""), "list");
},
    Q = function Q(e) {
  return x("list item style \"".concat(e, "\""), "listItem");
};

function X(e) {
  console.warn(e);
}

var N = {
  display: "none"
},
    Y = function Y(_ref10) {
  var e = _ref10.value,
      t = _ref10.isInline;
  var n = U(e._type);
  return t ? l.default.createElement("span", {
    style: N
  }, n) : l.default.createElement("div", {
    style: N
  }, n);
},
    Z = function Z(_ref11) {
  var e = _ref11.markType,
      t = _ref11.children;
  return l.default.createElement("span", {
    className: "unknown__pt__mark__".concat(e)
  }, t);
},
    ee = function ee(_ref12) {
  var e = _ref12.children;
  return l.default.createElement("p", null, e);
},
    te = function te(_ref13) {
  var e = _ref13.children;
  return l.default.createElement("ul", null, e);
},
    ne = function ne(_ref14) {
  var e = _ref14.children;
  return l.default.createElement("li", null, e);
},
    le = function le() {
  return l.default.createElement("br", null);
},
    re = {
  normal: function normal(_ref15) {
    var e = _ref15.children;
    return l.default.createElement("p", null, e);
  },
  blockquote: function blockquote(_ref16) {
    var e = _ref16.children;
    return l.default.createElement("blockquote", null, e);
  },
  h1: function h1(_ref17) {
    var e = _ref17.children;
    return l.default.createElement("h1", null, e);
  },
  h2: function h2(_ref18) {
    var e = _ref18.children;
    return l.default.createElement("h2", null, e);
  },
  h3: function h3(_ref19) {
    var e = _ref19.children;
    return l.default.createElement("h3", null, e);
  },
  h4: function h4(_ref20) {
    var e = _ref20.children;
    return l.default.createElement("h4", null, e);
  },
  h5: function h5(_ref21) {
    var e = _ref21.children;
    return l.default.createElement("h5", null, e);
  },
  h6: function h6(_ref22) {
    var e = _ref22.children;
    return l.default.createElement("h6", null, e);
  }
},
    D = {
  types: {},
  block: re,
  marks: F,
  list: K,
  listItem: O,
  hardBreak: le,
  unknownType: Y,
  unknownMark: Z,
  unknownList: te,
  unknownListItem: ne,
  unknownBlockStyle: ee
},
    g = w.createContext(D),
    oe = function oe(_ref23) {
  var e = _ref23.components,
      t = _ref23.children;
  var n = w.useMemo(function () {
    return B(D, e);
  }, [e]);
  return l.default.createElement(g.Provider, {
    value: n
  }, t);
};

function ae(_ref24) {
  var e = _ref24.value,
      t = _ref24.components,
      n = _ref24.listNestingMode,
      _ref24$onMissingCompo = _ref24.onMissingComponent,
      a = _ref24$onMissingCompo === void 0 ? X : _ref24$onMissingCompo;
  var f = a || se,
      h = Array.isArray(e) ? e : [e],
      I = y.nestLists(h, n || y.LIST_NEST_MODE_HTML),
      p = w.useContext(g),
      d = w.useMemo(function () {
    return t ? B(p, t) : p;
  }, [p, t]),
      r = w.useMemo(function () {
    return ue(d, f);
  }, [d, f]),
      o = I.map(function (s, c) {
    return r({
      node: s,
      index: c,
      isInline: !1,
      renderNode: r
    });
  });
  return t ? l.default.createElement(g.Provider, {
    value: d
  }, o) : l.default.createElement(l.default.Fragment, null, o);
}

var ue = function ue(e, t) {
  function n(r) {
    var o = r.node,
        s = r.index,
        c = r.isInline,
        u = o._key || "node-".concat(s);
    return y.isPortableTextToolkitList(o) ? f(o, s, u) : y.isPortableTextListItemBlock(o) ? a(o, s, u) : y.isPortableTextToolkitSpan(o) ? h(o, s, u) : y.isPortableTextBlock(o) ? I(o, s, u, c) : y.isPortableTextToolkitTextNode(o) ? p(o, u) : d(o, s, u, c);
  }

  function a(r, o, s) {
    var c = v({
      node: r,
      index: o,
      isInline: !1,
      renderNode: n
    }),
        u = e.listItem,
        i = (typeof u == "function" ? u : u[r.listItem]) || e.unknownListItem;

    if (i === e.unknownListItem) {
      var T = r.listItem || "bullet";
      t(Q(T), {
        type: T,
        nodeType: "listItemStyle"
      });
    }

    var k = c.children;

    if (r.style && r.style !== "normal") {
      var b = r,
          _T = b.listItem,
          W = S(b, ["listItem"]);
      k = n({
        node: W,
        index: o,
        isInline: !1,
        renderNode: n
      });
    }

    return l.default.createElement(i, {
      key: s,
      value: r,
      index: o,
      isInline: !1,
      renderNode: n
    }, k);
  }

  function f(r, o, s) {
    var c = r.children.map(function (k, b) {
      return n({
        node: k._key ? k : P(E({}, k), {
          _key: "li-".concat(o, "-").concat(b)
        }),
        index: o,
        isInline: !1,
        renderNode: n
      });
    }),
        u = e.list,
        i = (typeof u == "function" ? u : u[r.listItem]) || e.unknownList;

    if (i === e.unknownList) {
      var k = r.listItem || "bullet";
      t(J(k), {
        nodeType: "listStyle",
        type: k
      });
    }

    return l.default.createElement(i, {
      key: s,
      value: r,
      index: o,
      isInline: !1,
      renderNode: n
    }, c);
  }

  function h(r, o, s) {
    var c = r.markDef,
        u = r.markType,
        m = r.markKey,
        i = e.marks[u] || e.unknownMark,
        k = r.children.map(function (b, T) {
      return n({
        node: b,
        index: T,
        isInline: !0,
        renderNode: n
      });
    });
    return i === e.unknownMark && t(V(u), {
      nodeType: "mark",
      type: u
    }), l.default.createElement(i, {
      key: s,
      text: y.spanToPlainText(r),
      value: c,
      markType: u,
      markKey: m,
      renderNode: n
    }, k);
  }

  function I(r, o, s, c) {
    var T = v({
      node: r,
      index: o,
      isInline: c,
      renderNode: n
    }),
        u = T._key,
        m = S(T, ["_key"]),
        i = m.node.style || "normal",
        b = (typeof e.block == "function" ? e.block : e.block[i]) || e.unknownBlockStyle;
    return b === e.unknownBlockStyle && t(G(i), {
      nodeType: "blockStyle",
      type: i
    }), l.default.createElement(b, P(E({
      key: s
    }, m), {
      value: m.node,
      renderNode: n
    }));
  }

  function p(r, o) {
    if (r.text === "\n") {
      var s = e.hardBreak;
      return s ? l.default.createElement(s, {
        key: o
      }) : "\n";
    }

    return r.text;
  }

  function d(r, o, s, c) {
    var u = e.types[r._type],
        m = {
      value: r,
      isInline: c,
      index: o,
      renderNode: n
    };
    if (u) return l.default.createElement(u, E({
      key: s
    }, m));
    t(U(r._type), {
      nodeType: "block",
      type: r._type
    });
    var i = e.unknownType;
    return l.default.createElement(i, E({
      key: s
    }, m));
  }

  return n;
};

function v(e) {
  var t = e.node,
      n = e.index,
      a = e.isInline,
      f = e.renderNode,
      I = y.buildMarksTree(t).map(function (p, d) {
    return f({
      node: p,
      isInline: !0,
      index: d,
      renderNode: f
    });
  });
  return {
    _key: t._key || "block-".concat(n),
    children: I,
    index: n,
    isInline: a,
    node: t
  };
}

function se() {}

Object.defineProperty(exports, "toPlainText", {
  enumerable: !0,
  get: function get() {
    return y.toPlainText;
  }
});
exports.PortableText = ae;
exports.PortableTextComponentsProvider = oe;
exports.defaultComponents = D;
exports.mergeComponents = B;